/**
 * Пункты группы «О платформе» в меню: история компании, межбиржевой арбитраж,
 * VIKING, CScalp и торговые инструменты MOEX.
 *
 * Список один на шапку и на мобильное меню, чтобы две копии не разъехались.
 * Скрытые на контуре разделы отфильтрованы: на проде, пока страницы
 * партнёров и арбитража согласуются на тесте, в группе остаются история
 * компании и инструменты MOEX — остальные подхватятся сами, когда адреса
 * откроют.
 */

import { isHiddenRoute } from '@/constants/hidden-sections'

export type PlatformLink = { id: string, label: string, route: string }

/** Поддержка на сайте одна — бот в Telegram: туда же ведут подвал и мобильное меню. */
export const SUPPORT_URL = 'https://t.me/adfcapital_support_bot'

export const usePlatformLinks = () => {
  const { t } = useI18n()

  const links = computed<PlatformLink[]>(() => [
    { id: 'history', label: t('nav.history'), route: '/about' },
    { id: 'arbitrage', label: t('nav.arbitrage'), route: '/arbitrage' },
    { id: 'viking', label: t('nav.vikingMenu'), route: '/viking' },
    { id: 'cscalp', label: t('nav.cscalpMenu'), route: '/cscalp' },
    { id: 'instruments', label: t('nav.moexTools'), route: '/instruments' },
  ].filter(link => !isHiddenRoute(link.route)))

  return { links }
}
